import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AddReceipe } from '../models/add-receipe';
import { Ingredients } from '../models/ingredients';
import { ControllerApiPath } from '../services/constant';
import { SharedServiceService } from './shared-service.service';

@Injectable({
  providedIn: 'root'
})
export class RecipeService {
  public recipeListSubject = new BehaviorSubject<any[]>([]);
  public recipeList$ = this.recipeListSubject.asObservable();
  private apiBaseUrl: string;

  constructor(private http: HttpClient, private sharedService: SharedServiceService) {
    this.apiBaseUrl = this.sharedService.baseUrl();
  }

  addIngredient(data: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}${ControllerApiPath.ingredient}`;
    return this.http.post<Ingredients>(url, data, { headers }).pipe(map(res => res));
  }

 searchIngredient(param: any): Observable<Ingredients[]> {
  const headers = this.sharedService.createAuthorizationHeader();
  const url = `${this.apiBaseUrl}${ControllerApiPath.ingredient}?ingredient=${param}`;
  return this.http.get<any>(url, { headers }).pipe(
    map(response => response.results || [])
  );
}

  refreshRecipes(pageNumber: number = 1): void {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}${ControllerApiPath.recipe}?pageSize=10&page=${pageNumber}`;
    this.http.get<any>(url, { headers }).subscribe((res) => {
      const recipesArray = res.data || res.recipes || res;
      this.recipeListSubject.next(Array.isArray(recipesArray) ? recipesArray : []);
    });
  }
 
 
  addReciepe(data: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}${ControllerApiPath.recipe}`;
    return this.http.post<AddReceipe>(url, data, { headers }).pipe(
      map((recipe: AddReceipe) => {
        this.refreshRecipes();
        return recipe;
      })
    );
  }

  reciepes(page: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}${ControllerApiPath.recipe}?pageSize=10&page=${page}`;
    return this.http.get(url, { headers });
  }

  getRecipeById(id: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}${ControllerApiPath.recipe}/${id}`;
    return this.http.get<AddReceipe>(url, { headers }).pipe(map((recipe: AddReceipe) => recipe));
  }

  updateRecipe(payload: { recipe: AddReceipe }, id: string) {
  const headers = this.sharedService.createAuthorizationHeader();
  const url = `${this.apiBaseUrl}${ControllerApiPath.recipe}/${id}`;
  return this.http.put(url, payload, { headers });
}



searchRecipes(
  query: string = '',
  diets: string = '',
  allergies: string = '',
  fromCalories: string = '0',
  toCalories: string = '99999',
  page: number = 1,
  pageSize: number = 10
): Observable<any> {
  const headers = this.sharedService.createAuthorizationHeader();
  const url = `${this.apiBaseUrl}${ControllerApiPath.recipe}/search`;
  
  
  let params = new HttpParams()
    .set('q', query.trim())  
    .set('diets', diets)
    .set('allergies', allergies)
    .set('fromCalories', fromCalories)
    .set('toCalories', toCalories)
    .set('page', page.toString())
    .set('pageSize', pageSize.toString());

  console.log('Search Request:', { url, params: params.toString() });
  
  return this.http.get(url, { headers, params }).pipe(
    catchError(error => {
      console.error('Search error:', error);
      return throwError(() => new Error('Failed to search recipes'));
    })
  );
}
  getAllergies(): Observable<any[]> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}${ControllerApiPath.allergy}`;
    return this.http.get<any[]>(url, { headers });
  }

  addAllergy(tagName: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}${ControllerApiPath.allergy}`;
    return this.http.post<any>(url, { tagName }, { headers });
  }

  getDiets(): Observable<any[]> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}${ControllerApiPath.diet}`;
    return this.http.get<any[]>(url, { headers });
  }

  addDiet(tagName: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}${ControllerApiPath.diet}`;
    return this.http.post<any>(url, { tagName }, { headers });
  }

  getLoggedUser() {
    return this.sharedService.getLoggedInUser();
  }
  getAllRecipes(): Observable<any[]> {
  const headers = this.sharedService.createAuthorizationHeader();
  const url = `${this.apiBaseUrl}${ControllerApiPath.recipe}?pageSize=10000&page=1`; // big pageSize to get all
  return this.http.get<any>(url, { headers }).pipe(
    map(res => res.data || res.recipes || [])
  );
}


  getAllMeasure() {
    return this.sharedService.allMeasurement;
  }
}